<template>
  <div class="container">
    <transition name="fade-up">
      <div class="confirm-wrapper" v-if="removeConfirm || xlsDownload">
      <div class="layout" @click="cancelModal"></div>
      <div class="confirm-container">
        <div class="confirm-header" :class="{'delete-header': removeConfirm}">
          <span v-if="removeConfirm">Result Delete</span>
          <span>Download xls</span>
        </div>
        <div class="confirm-body">
          <div v-if="removeConfirm">Do you Really want to delete this result?</div>
          <div v-else class="language-choose">
            <label class="dado__label">Choose language</label>
            <v-select :options="getLangOptions" :flags="true" :search="true" :value="lang" @input="lang = $event"/>
          </div>
        </div>
        <div class="confirm-actions">
          <button @click="cancelModal">Cancel</button>
          <button v-if="removeConfirm" class="delete" @click="removeResult()">Delete</button>
          <button v-else class="download" @click="onExport()">Download xls</button>
        </div>
      </div>
    </div>
    </transition>
    <div class="row dado__head">
      <div class="col-12 col-lg-3">
        <div class="title">Surveys<br>Completed</div>
      </div>
      <div class="col-12 col-lg-9">
        <div class="row dado__separately">
          <div class="col-12 col-md-4 mb-3">
            <label class="dado__label">Sorting by</label>
            <vue-select v-model="filters.sort" :options="sortOptions" @change="onFilter(false)"/>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label class="dado__label">Country</label>
            <vue-select v-model="filters.country" :options="getCountriesOptions(true)" @change="onFilter(false)"/>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label class="dado__label">Monitor</label>
            <vue-select v-model="filters.monitor" :options="getMonitorsWithResultsOptions(true)" @change="onFilter(false)"/>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label class="dado__label">Start date</label>
            <datepicker id="start-date"
                        :disabled-dates="disabled_dates"
                        :clear-button="true"
                        class="search__field"
                        v-model="filters.start_date"
                        @selected="onFilter(false)"/>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label class="dado__label">End date</label>
            <datepicker id="end-date"
                        :disabled-dates="disabled_dates"
                        :clear-button="true"
                        class="search__field"
                        v-model="filters.end_date"
                        @selected="onFilter(false)"/>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label class="dado__label">Partner</label>
            <vue-select v-model="filters.partner" :options="getPartnersOptions(true)" @change="onFilter(false)"/>
          </div>

           <div class="col-12 col-md-12">
            <label class="dado__label">Enter Poll Id</label>
            <div class="search">
              <input type="text" v-model="filters.poll_id" placeholder="Type poll id here..." class="search__field"/>
              <span class="form__del" :class="{'d-block': filters.poll_id}" @click="onClearName"></span>
              <button type="submit" class="search__btn" @click="onFilter(false)"></button>
            </div>
          </div>


        </div>
      </div>
    </div>
    <div class="row">
      <v-sidebar/>
      <div class="col-12 col-lg-10">
        <div class="dado__array">
          <div class="dado__bred">
            <table class="table">
              <thead class="table__thead">
              <tr class="table__tr">
                <th class="table__th">ID</th>
                <th class="table__th">Monitor's Name</th>
                <th class="table__th">Country</th>
                <th class="table__th">
                  <div class="table__date">
                    Date & Time
                    <input type='text' v-if="0" class='datepicker-here datepicker__date' data-language='en'><span
                      v-if="0" class='table__opener'></span>
                  </div>
                </th>
                <th class="text-right flex border-0 action-block">
                  <div class="btn__add h-100" @click="xlsDownload = true" v-if="this.filters.poll_id > 0">
                    <svg class='dado__icon' width="18" height="18" viewBox="0 0 18 18" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <g>
                        <path
                            d="M7.3126 10.3125H8.2501V12.75C8.2501 13.164 8.5861 13.5 9.0001 13.5C9.4141 13.5 9.7501 13.164 9.7501 12.75V10.3125H10.6876C11.1871 10.3125 11.4384 9.70575 11.0851 9.3525L9.3976 7.665C9.2881 7.55475 9.1441 7.5 9.0001 7.5C8.8561 7.5 8.7121 7.55475 8.6026 7.665L6.9151 9.3525C6.56185 9.70575 6.8131 10.3125 7.3126 10.3125Z"
                            fill="white"/>
                        <path
                            d="M11.25 16.5H6.75C5.92275 16.5 5.25 15.8273 5.25 15V14.25C5.25 13.836 5.586 13.5 6 13.5C6.414 13.5 6.75 13.836 6.75 14.25V15H11.25V14.25C11.25 13.836 11.586 13.5 12 13.5C12.414 13.5 12.75 13.836 12.75 14.25V15C12.75 15.8273 12.0772 16.5 11.25 16.5Z"
                            fill="white"/>
                        <path
                            d="M15.75 15.1875H14.625C14.2102 15.1875 13.875 14.8515 13.875 14.4375C13.875 14.0235 14.2102 13.6875 14.625 13.6875H15.75C16.164 13.6875 16.5 13.3507 16.5 12.9375V5.25C16.5 4.83675 16.164 4.5 15.75 4.5H7.6875C7.488 4.5 7.2975 4.42125 7.15725 4.28025L5.877 3H2.25C1.836 3 1.5 3.33675 1.5 3.75V12.9375C1.5 13.3507 1.836 13.6875 2.25 13.6875H3.375C3.78975 13.6875 4.125 14.0235 4.125 14.4375C4.125 14.8515 3.78975 15.1875 3.375 15.1875H2.25C1.0095 15.1875 0 14.178 0 12.9375V3.75C0 2.5095 1.0095 1.5 2.25 1.5H6.1875C6.387 1.5 6.5775 1.57875 6.71775 1.71975L7.998 3H15.75C16.9905 3 18 4.0095 18 5.25V12.9375C18 14.178 16.9905 15.1875 15.75 15.1875Z"
                            fill="white"/>
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="18" height="18" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    XLS
                  </div>
                  <div class="btn__add btn__update h-100" @click="dataUpdate">
                    <svg  class="update-icon" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 32 32"  xml:space="preserve">
                            <g id="spin">
                              <g>
                                <path style="fill:#FFF;" d="M25.883,6.086l-2.82,2.832C24.953,10.809,26,13.324,26,16c0,5.516-4.484,10-10,10v-2l-4,4l4,4v-2
                                  c7.719,0,14-6.281,14-14C30,12.254,28.539,8.734,25.883,6.086z"/>
                                <path style="fill:#FFF;" d="M20,4l-4-4v2C8.281,2,2,8.281,2,16c0,3.746,1.461,7.266,4.117,9.914l2.82-2.832
                                  C7.047,21.191,6,18.676,6,16c0-5.516,4.484-10,10-10v2L20,4z"/>
                              </g>
                            </g>
                    </svg>
                  </div>
                </th>
              </tr>
              </thead>
              <tbody class="table__tbody">
              <tr class="table__tr" v-for="result of getResults">
                <td class="table__td">{{ result.id }}</td>
                <td class="table__td">{{ result.monitor ? result.monitor.name : '' }}</td>
                <td class="table__td">{{ result.country ? result.country.name : '' }}</td>
                <td class="table__td">{{ result.created_at }}</td>
                <td class="table__td text-right">
                  <router-link :to="'results/' + result.id" class="table__view">View Report</router-link>
                  <span class="remove-icon-container" @click="removeConfirm = result.id">
                    <svg x="0px" y="0px" class="remove-icon"
                         viewBox="0 0 490.29 490.29" style="color:#FFF" xml:space="preserve" >
                      <g>
                        <rect style="fill:#ff0000;" x="206.343" y="-62.678" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 591.6399 245.173)" width="77.399" height="615.594"/>
                        <rect style="fill:#ff0000;" x="-9.144" y="335.976" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -231.1054 191.4143)" width="249.298" height="77.399"/>
                        <rect style="fill:#ff0000;" x="250.136" y="77.228" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 721.7715 -67.1118)" width="249.298" height="77.399"/>
                      </g>
                    </svg>
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <v-pagination
              v-if="pages > 1"
              :page-count="pages"
              :click-handler="onChangePage"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination'"
              :prev-class="'pagination__prev'"
              :next-class="'pagination__next'"
              :page-class="'pagination__item'"
              :hide-prev-next="true"
              :active-class="'active'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import {mapActions, mapMutations, mapGetters} from 'vuex'

  export default {
    name: "Results",
    components: {
      Datepicker
    },
    data() {
      return {
        lang: 'select',
        filters: {
          country: null,
          start_date: null,
          end_date: null,
          monitor: 0,
          partner: 0,
          poll_id: null,
          sort: 'created_at desc',
          page: 1
        },
        sortOptions: [
          {id: 'monitor_name asc', text: 'Name ascending'},
          {id: 'monitor_name desc', text: 'Name descending'},
          {id: 'created_at asc', text: 'Date & Time old first'},
          {id: 'created_at desc', text: 'Date & Time new first'},
        ],
        removeConfirm: false,
        xlsDownload : false
      }
    },
    computed: {
      ...mapGetters([
        'getAuthUser',
        'getResults',
        'getResultsFilters',
        'getResultsPagination',
        'getDateRange',
        'getCountriesOptions',
        'getMonitorsWithResultsOptions',
        'getPartnersOptions',
      ]),
      getLangOptions () {
        //let options = JSON.parse(JSON.stringify(this.$store.getters.getLangOptions))
        //options.unshift( {label: 'Input language', value: null})
        //return options
        return [{label: 'Input language', value: null}, {label: 'English', value: 'en'}]
      },
      pages() {
        return Math.ceil(this.getResultsPagination.count / this.getResultsPagination.per_page)
      },
      disabled_dates() {
        if (this.getDateRange.length) {
          return {
            to: new Date(this.getDateRange[0]),
            from: new Date(this.getDateRange[1]),
          }
        }
        return {}
      }
    },
    mounted() {
      this.setResultsFilters(this.filters)
      this.queryResults()
      this.queryUsers()
      this.queryPartners()
    },
    methods: {
      ...mapActions([
        'showModal',
        'queryResults',
        'exportResults',
        'queryUsers',
        'queryPartners',
      ]),
      ...mapMutations([
        'setResultsFilters',
      ]),
      cancelModal() {
        this.removeConfirm = false
        this.xlsDownload = false
      },
      
       onClearName() {
        this.filters.poll_id = null
        this.onFilter()
        this.onFilter(false)
      },

      async dataUpdate () {
        try {
          await this.$store.dispatch('')
          await this.$router.push({name: 'Dashboard'})
        } catch (e) {
          console.log(e)
        }
      },
      async removeResult () {
        try {
          await this.$store.dispatch('deleteResult', this.removeConfirm)
          this.removeConfirm = false
        } catch (e) {
          console.log(e)
        }
      },
      onFilter(page) {
        this.filters.page = 1
        if (page)
          this.filters.page = page
        this.setResultsFilters(this.filters)
        this.queryResults()
      },
      onChangePage(page) {
        this.onFilter(page)
      },
      async onExport() {
        try {
          const result = await this.exportResults(this.lang)
          if (result) this.cancelModal()
        } catch (e) {
          console.log(e)
        }

      },
    }
  }
</script>

<style scoped>
  .fade-up-enter-active, .fade-up-leave-active {
    transition: opacity .5s;
  }
  .fade-up-enter, .fade-up-leave-to {
    opacity: 0;
  }
  .action-block{
    display:flex;
  }
  .action-block .btn__add{
    padding:0 5px;
    height:45px !important;
    display:flex;
    align-items: center;
    justify-content: center;
  }
  .action-block .btn__update{
    margin-left:5px;
    width:60px;
  }
  .action-block .btn__update:hover .update-icon path{
    fill:#39833C !important;
  }
  .btn__update .update-icon{
    width:25px;
    height:25px;
    margin:0;
  }
  .remove-icon-container{
    margin-left:20px;
    margin-right:5px;
    cursor: pointer;
  }
  .remove-icon-container .remove-icon{
    width:20px;
    height:20px;
    opacity:0.7;
    transition: opacity 0.3s ease-in-out;
  }
  .remove-icon-container:hover .remove-icon{
    opacity:1;
  }
  .confirm-wrapper{
    position:fixed;
    left:0;
    top:0;
    z-index:9999;
    display:flex;
    align-items:center;
    justify-content:center;
    width:100%;
    height:100%;
    background: rgba(0,0,0,0.7)
  }
  .confirm-wrapper .layout{
    display:flex;
    position:fixed;
    width:100%;
    height:100%;
    z-index:1;
  }
  .confirm-wrapper .confirm-container{
    background:#fff;
    width:450px;
    max-width:100%;
    z-index:2;
  }
  .confirm-wrapper .confirm-container .confirm-header.delete-header{
    background: #AB2C2CFF;
  }
  .confirm-wrapper .confirm-container .confirm-header{
    background: #39833C;
    padding:20px;
    color:#FFF;
    font-size:18px
  }
  .confirm-wrapper .confirm-container .confirm-body{
    padding:20px;
    min-height:100px;
    font-size:18px;
  }
  .confirm-wrapper .confirm-container .confirm-actions{
    padding:0px;
    display:flex;
    justify-content:space-between;
  }
  .confirm-wrapper .confirm-container .confirm-actions button{
    display:flex;
    justify-content: center;
    align-items:center;
    border:none;
    height:55px;
    background:#CCC;
    width:50%;
    font-size:18px;
    transition:0.3s;
  }
  .confirm-wrapper .confirm-container .confirm-actions button:active,
  .confirm-wrapper .confirm-container .confirm-actions button:hover,
  .confirm-wrapper .confirm-container .confirm-actions button:focus{
    border:none;
    outline:none;
  }
  .confirm-wrapper .confirm-container .confirm-actions button.delete{
    background: #AB2C2CFF;
    color:#FFF;
  }
  .confirm-wrapper .confirm-container .confirm-actions button.download{
    background:#39833C;
    color:#FFF;
  }
  .confirm-wrapper .confirm-container .confirm-actions button.delete:hover{
    background:#ae5252;
  }
  .confirm-wrapper .confirm-container .confirm-actions button.download:hover{
    background: #39823c;
  }
</style>